import { defaultHeight } from '@Common/Controls/SimpleGridLight/Editors/EditorProps';
import ColorHelper from '@Common/Helpers/ColorHelper';
import StylesHelper from '@Common/Helpers/StylesHelper';
import { SolidBackground } from '@InstanceFactory';
import { BackgroundEditorTypes, dropDownBackgroundEditor, IDropDownBackgroundEditor, INamedColorsDefinition } from '../../index';
import { TwoStateCellEditor } from '../Editors/GridEditors';
import { GridCell } from '../GridCell';
import { GridColumn } from '../GridColumn';
import { GridRow } from '../GridRow';
import { RowCollection } from '../RowCollection';
import { ICellEditor, IGridColumnEditor } from '../SimpleGridLight';

export interface IGridBackgroundEditorSetting {
    onlyColor?: boolean;
    namedColors?: INamedColorsDefinition;
}

export class GridBackgroundEditor implements IGridColumnEditor {
    constructor(private setting: IGridBackgroundEditorSetting) {}

    public getEditor(row: GridRow, column: GridColumn): ICellEditor {
        return new CellBackgroundEditor(row.getCell(column), this.setting);
    }

    public buildEditorForAll(column: GridColumn) {}

    public refreshAll(rows: RowCollection) {}
}

export class CellBackgroundEditor extends TwoStateCellEditor<IDropDownBackgroundEditor, IGridBackgroundEditorSetting> {
    private namedColors: IMap<string>;

    constructor(cell: GridCell, setting: IGridBackgroundEditorSetting) {
        cell.tableCell().addClass('visibleEditor');
        const types = setting.onlyColor ? [BackgroundEditorTypes.solidBackground] : null;
        const editor = dropDownBackgroundEditor({
            types,
            height: `${defaultHeight}px`,
            namedColors: setting.namedColors
        });
        editor.onChange(() => {
            let value = editor.getValue();
            if (this.setting.onlyColor && value) {
                value = value.color;
            }
            this.cell.value(value);
        });
        const view = $('<div>').addClass('dropDownColorPickerEditor');
        super(cell, editor, view, setting);

        if (setting.namedColors === true) {
            this.namedColors = ColorHelper.getCustomColors();
        } else if (typeof setting.namedColors === 'object') {
            this.namedColors = setting.namedColors as IMap<string>;
        }
    }

    public beginEdit() {
        let value = this.cell.value();
        if (this.setting.onlyColor && value) {
            const bgValue = SolidBackground.create();
            bgValue.color = value;
            value = bgValue;
        }
        this.inner.setValue(value);
        super.beginEdit();
    }

    public refresh() {
        const value: string = this.cell.value();
        if (this.setting.onlyColor) {
            this.view.css('backgroundColor', ColorHelper.getRepresentationColor(value || ''));
        } else {
            this.view.css('background', StylesHelper.getBackground(value, this.namedColors));
        }
    }
}

namespace manualTests {
    export function gridBackgroundEditor(root: JQuery) {
        // const grid = new Grid({
        //     columns: [
        //         {
        //             dataIndex: 'backgroundColor',
        //             editor:    new Grid.editors.GridBackgroundEditor({onlyColor: true})
        //         },
        //         {
        //             dataIndex: 'color',
        //             editor:    new Grid.editors.GridColorEditor({})
        //         }
        //     ]
        // });
        //
        // grid.appendData([
        //     {backgroundColor: null, color: null},
        //     {backgroundColor: 'rgba(125,0,0,0.5)', color: 'rgba(125, 0, 0, 1)'}
        // ]);
        //
        // grid.getControl().appendTo(root);
        // grid.adjust(300, 200);
    }
}
